import { Injectable } from '@angular/core';
import { BaseApiClientCompanySettingsService } from './base-api-client-company-settings.service';

@Injectable({
	providedIn: 'root'
})
export class ApiClientCompanySettingsService extends BaseApiClientCompanySettingsService {}
